export default "__VITE_ASSET__BpH92tOG__"